import { GraphComponent } from '@ardoq/yfiles';
import { ClientNodeLocator } from 'tabview/canvasRendering/canvasHitTestRegistry';
import { graphLocationToPageLocation } from 'tabview/graphComponent/graphLocationToPageLocation';

/**
 * The mirror of `toClientModelHitTest`: where yFiles draws a given node, rather
 * than which node it draws at a given point. Asked by graph id, because a
 * grouping can render one component as several nodes.
 *
 * Page coordinates stand in for client ones, the same way the hit test feeds
 * client coordinates to `pageToWorldCoordinates` - the app's window does not
 * scroll.
 */
export const toClientNodeLocator =
  (graphComponent: GraphComponent): ClientNodeLocator =>
  nodeId => {
    // Asked every frame of a drag, so no copy of the node collection: the
    // loop leaves as soon as it has its answer.
    for (const node of graphComponent.graph.nodes) {
      if (node.tag?.id !== nodeId) continue;
      const { x, y } = graphLocationToPageLocation(
        graphComponent,
        node.layout.center
      );
      return { x, y };
    }
    return null;
  };
